import React, {useState} from 'react'
import './index.scss'

export default function FaqItem({
                                  title,
                                  description,
                                  id,
  is_open = false
                                }) {
  const [show, setShow] = useState(is_open);

  return (
    <div key={id} onClick={() => {
      setShow(!show)
    }} className={`faqItem ${show ? 'faqItem_active' : ''}`}>
      <div className="faqItem__head">
        <p className="faqItem__title">{title}</p>
        <div className="faqItem__btn">
          <span>
            <img src={`${show ? '../../assets/icons/minus.svg' : '../../assets/icons/plus.svg'}`} alt=""/>
          </span>
        </div>
      </div>
      <pre className="faqItem__desc">
        {description}
      </pre>
    </div>
  )
}
